// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SupportedSection_wrapper__g5hTo","title":"SupportedSection_title__3PWNS","container":"SupportedSection_container__3PVaw","logo":"SupportedSection_logo__1N05t"};